import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import RootState from './root_state';

import user from './modules/user';
import classrooms from './modules/classrooms';
import enrollments from './modules/enrollments';
import assessments from './modules/assessments';
import comments from './modules/comments';
import notifications from './modules/notifications';
import notes from './modules/notes';
import boardsClassrooms from './modules/boardsClassrooms';
import boardsTeachers from './modules/boardsTeachers';
import teachers from './modules/teachers';
import boards from './modules/boards';
import boardsDegrees from './modules/boardsDegrees';
import materials from './modules/materials';
import knowledges from './modules/knowledges';
import lists from './modules/lists';
import listItems from './modules/listItems';
import listSessions from './modules/listSessions';
import boardSections from './modules/boardSections';
import texts from './modules/texts';
import images from './modules/images';
import videos from './modules/videos';
import contents from './modules/contents';
import articles from './modules/articles';
import questions from './modules/questions';
import lives from './modules/lives';
import appointments from './modules/appointments';
import roles from './modules/roles';
import staffs from './modules/staffs';
import readings from './modules/readings';
import knowledgeAssociations from './modules/knowledgeAssociations';
import assertions from './modules/assertions';
import progresses from './modules/progresses';
import replies from './modules/replies';
import solutions from './modules/solutions';
import providerAssociations from './modules/providerAssociations';
import reactions from './modules/reactions';
import zoomSignature from './modules/zoomSignature';
import forumAPIModule from './forumAPI';
import alumniProfile from './modules/alumni-profile';
import microcertificates from './modules/microcertificates';
import exerciseCommentAttachments from './modules/exerciseCommentAttachments';
import currentPeriod from './modules/periods';
import undergradCourses from '@/store/undergrad/courses';
import undergradSubmodules from '@/store/undergrad/submodules';
import undergradDisciplinesInstances from '@/store/undergrad/disciplines-instances';
import gradeWorthyActivities from '@/store/undergrad/gradeWorthyActivities';
import undergradCycles from '@/store/undergrad/cycle';
import undergradLessons from '@/store/undergrad/lessons';
import undergradProgress from '@/store/undergrad/progress';
import chimeraCourses from '@/store/chimera/courses';
import postGradCourses from '@/store/post-grad/courses';
import tour from '@/store/modules/tour';
import undergradStudyCalendar from '@/store/undergrad/studyCalendar';
import gdh from '@/store/modules/growth/growthDataHub';
import calendar from '@/store/modules/calendar';
import documents from '@/store/modules/documents';
import onboarding from './modules/onboarding';

Vue.use(Vuex);

export const store: StoreOptions<RootState> = {
  state: {},
  modules: {
    zoomSignature,
    reactions,
    user,
    forumAPIModule,
    comments,
    exerciseCommentAttachments,
    classrooms,
    enrollments,
    assessments,
    boardsClassrooms,
    boards,
    boardsDegrees,
    materials,
    knowledges,
    lists,
    listItems,
    listSessions,
    boardSections,
    texts,
    images,
    videos,
    contents,
    articles,
    questions,
    lives,
    appointments,
    roles,
    staffs,
    readings,
    knowledgeAssociations,
    assertions,
    progresses,
    replies,
    solutions,
    providerAssociations,
    alumniProfile,
    microcertificates,
    gradeWorthyActivities,
    boardsTeachers,
    teachers,
    notifications,
    notes,
    currentPeriod,
    undergradCourses,
    undergradDisciplinesInstances,
    undergradSubmodules,
    undergradCycles,
    undergradLessons,
    undergradProgress,
    chimeraCourses,
    postGradCourses,
    tour,
    undergradStudyCalendar,
    gdh,
    calendar,
    documents,
    onboarding,
  },
};

export default new Vuex.Store<RootState>(store);
